import type { ComponentProps } from 'react';
import type { Components, ExtraProps } from 'react-markdown';

type HeadingTag = 'h4' | 'h5' | 'h6';
type HeadingProps = ComponentProps<'h4'> & ExtraProps;

/**
 * Assistant reply headings start at h4 under the h2 "Chat messages" region.
 * The h3 "Message input" label lives in the input region at the panel bottom.
 */
function renderAt(Tag: HeadingTag) {
  return function MarkdownHeading({ node, ...rest }: HeadingProps) {
    void node;
    return <Tag {...rest} />;
  };
}

export const markdownHeadingComponents: Components = {
  h1: renderAt('h4'),
  h2: renderAt('h5'),
  h3: renderAt('h6'),
  h4: renderAt('h6'),
  h5: renderAt('h6'),
  h6: renderAt('h6'),
};
